import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Dispatch } from 'redux';
import { CSVLink } from 'react-csv';

import { getUsers } from '../../../repositories/UserRepository';
import { hasPrivilege, adEnabled } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { getSorting, getFilters, getSearch } from '../../../stores/tables/selectors';
import { Data } from 'react-csv/components/CommonPropTypes';
import { TableFilters, TableSorting } from '../../../stores/tables/state';
import { getApplicationName } from '../../../stores/applications/selectors';
import { getGroupName } from '../../../stores/groups/selectors';
import { getWorkspaceName } from '../../../stores/workspaces/selectors';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    adEnabled?: boolean;
    sorting: TableSorting;
    filters: TableFilters;
    search: string;
    getApplicationName: (id: string) => string;
    getGroupName: (id: string) => string;
    getWorkspaceName: (id: string) => string;
}
interface State {
    csvData: Data;
}

const initialState: State = {
    csvData: []
};

class ExportReportAction extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = initialState;
  }

  public render() {
    const t = this.props.translate;
    if (this.props.hasPrivilege(['USER_ADMIN', 'SUPER_ADMIN'])) {
      return (
        <React.Fragment>
          <CSVLink
            data={this.state.csvData}
            filename='users.csv'
            className='hidden'
            target='_blank'
            ref={(r: any) => (this.csvLink = r)}
            separator=';'
          />
          <Button onClick={this.writeCSVReport} className='mr-2'>
            <FontAwesomeIcon icon={['fal', 'th-list']} className='mr-4' />
            {t('users.button.userReport')}
          </Button>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }

  private writeCSVReport = () => {
    const t = this.props.translate;
    getUsers(
      999999,
      0,
      {
        column: this.props.sorting?.column ?? 'email',
        order: this.props.sorting?.order ?? 'asc',
      },
      {
        a: this.props.filters?.a,
        g: this.props.filters?.g,
        w: this.props.filters?.w,
      },
      this.props.search
    ).then(users => {
      let csvList = [
        [
          t('users.table.header.email'),
          t('users.table.header.firstName'),
          t('users.table.header.lastName'),
          this.props.adEnabled ? t('users.table.header.adIdentifier') : [],
          t('users.table.header.privileges'),
          t('users.table.header.applications'),
          t('users.table.header.groups'),
          t('users.table.header.workspace'),
          t('users.table.header.lastLogin'),
          t('users.table.header.createdat'),
          t('users.table.header.active')
        ].flat(),
      ];
      users.items.forEach(user => {
        csvList.push(
          [
            user.email ?? user.username ?? '',
            user.first_name ?? '',
            user.last_name ?? '',
            this.props.adEnabled ? user.ad_identifier ?? '' : [],
            user.privileges?.map(privilege => privilege.name).join(',') ?? '',
            user.applications?.map(a => this.props.getApplicationName(a.id)).join(',') ?? '',
            user.groups?.map(g => this.props.getGroupName(g.id)).join(',') ?? '',
            user.workspace?.id ? this.props.getWorkspaceName(user.workspace?.id) : '',
            user.last_login ?? '',
            user.createdAt ?? '',
            user.active ? t('users.report.active.yes') : t('users.report.active.no')
          ].flat()
        );
      });
      this.setState({ csvData: csvList }, () => {
        this.csvLink.link.click();
      });
    });
  };
  private csvLink: any;
}


const mapStateToProps = (state: RootState) => {
    return {
        hasPrivilege: hasPrivilege(state),
        adEnabled: adEnabled(state),
        sorting: getSorting(state, 'users'),
        filters: getFilters(state, 'users'),
        search: getSearch(state, 'users'),
        getApplicationName: getApplicationName(state),
        getGroupName: getGroupName(state),
        getWorkspaceName: getWorkspaceName(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(ExportReportAction));